import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { Rating } from "@mui/material";
import React, { FunctionComponent, useState } from "react";
import AcxInputLabel from "./AcxInputLabel";

interface OwnProps {
    id: string; // THIS MUST BE UNIQUE (not sure why but it will break if not)
    value?: number | null;
    ratingLabels?: Record<number, string>;
    onChange?: (newRating: number | null) => void;
    label?: string;
    max: number;
    precision?: number;
    disabled?: boolean;
    size?: "large" | "medium" | "small";

    iconFilledColor?: string;
    iconHoverColor?: string;

    infoText?: string;
}

type Props = OwnProps;

interface StyledRatingProps {
    iconFilledColor?: string;
    iconHoverColor?: string;
}

const AcxStarRating: FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = (props) => {
    const [focused, setFocused] = useState<boolean | undefined>();
    const [hover, setHover] = React.useState<number | undefined>(undefined);

    const StyledRating = styled(Rating, {
        shouldForwardProp: (prop) =>
            prop !== "iconFilledColor" && prop !== "iconHoverColor",
    })<StyledRatingProps>(({ theme, iconFilledColor, iconHoverColor }) => ({
        "& .MuiRating-iconFilled": {
            color: iconFilledColor ?? theme.palette.secondary.main,
        },
        "& .MuiRating-iconHover": {
            color: iconHoverColor ?? theme.palette.secondary.light,
        },
    }));

    return (
        <div
            style={{ display: "flex", alignItems: "center" }}
            onMouseLeave={() => setHover(undefined)}
        >
            <div>
                {props.label && (
                    <AcxInputLabel
                        id={`StarRating-${props.label}`}
                        infoText={props.infoText}
                        focused={focused}
                        labelText={props.label}
                        disabled={props.disabled}
                        sx={{
                            fontSize: "13px",
                            letterSpacing: 0,
                            lineHeight: "20px",
                            userSelect: "none",
                        }}
                    />
                )}
                <StyledRating
                    disabled={props.disabled}
                    size={props.size}
                    onMouseOver={() => setFocused(true)}
                    onMouseLeave={() => setFocused(false)}
                    onChangeActive={(event, newHover) => {
                        setHover(newHover);
                    }}
                    name={"StarRating-" + props.id}
                    max={props.max}
                    precision={props.precision ?? 1}
                    value={props.value}
                    emptyIcon={<StarBorderIcon fontSize="inherit" />}
                    onChange={(event, newValue) => {
                        props.onChange?.(newValue);
                    }}
                />
            </div>
            {props.ratingLabels && hover !== undefined && (
                <div style={{ marginLeft: 1, paddingTop: 0 }}>
                    <Typography
                        sx={{
                            color: (theme) => theme.palette.text.secondary,
                            fontSize: "12px",
                            letterSpacing: 0,
                            lineHeight: "20px",
                            userSelect: "none",
                        }}
                    >
                        {props.ratingLabels[hover]}
                    </Typography>
                </div>
            )}
        </div>
    );
};

export default AcxStarRating;
